module.exports = __webpack_public_path__ + "img/logo.e3ec5528.svg";